import React, { useEffect } from "react";
import BiddingScreen from "../Bidding/BiddingScreen";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { tenderSpecefic } from "../../../Redux/Slices/auctionSlice";
import BiddingConsumer from "../../../pages/TokenAccess/ConsumerGenerator/Auction/ReverseAuction/BiddingConsumer";
import BiddingGenerator from "../../../pages/TokenAccess/ConsumerGenerator/Auction/ReverseAuction/BiddingGenerator";
import AuctionPageDashboard from "../../../pages/TokenAccess/ConsumerGenerator/Auction/AuctionPageDashboard";

const OngoingRa = ({ type }) => {
  const location = useLocation();
  let tenderId = location?.search?.split("=")[1];
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole
  ).toLowerCase();
  const dispatch = useDispatch();

  useEffect(() => {
    getAuction();
  }, []);

  const getAuction = () => {
    dispatch(tenderSpecefic(tenderId));
  };
  return (
    <>
      {role === "consumer" ? (
        <BiddingConsumer type={type} />
      ) : role === "generator" ? (
        <BiddingGenerator type={type} />
      ) : (
        <AuctionPageDashboard />
      )}
    </>
  );
};

export default OngoingRa;
